import styled from 'styled-components/macro';


export const Background = styled.div`
    dispaly:flex;
    flex-direction: column;
    height: 100vh;
    max-width: 100vw;
    position: relative;
    overflow: hidden;
`;

export const Video = styled.div`
    background-color: #000000;
    
    video {
        object-fit: cover;
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
      }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    white-space: nowrap;

    @media (max-width: 1350px) {
        margin-top: 3rem;
    }
`;

export const Container = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Logo = styled.img`
    position: absolute;
    top: 6%;
    left: 2%;
    height: 50px;
    width: 175px;

    @media(max-width: 1350px) {
        top: 2%;
        left: 50%;
        transform: translateX(-50%);
    }
    @media(max-width: 850px) {
        // top: 5%;
        height: 70px;
        width: 250px;
    }
`;